/**
 * Stubs for Next.js server-only features to allow static export.
 * These will return empty values or do nothing at runtime in the browser.
 */

export const cookies = () => ({
  get: (name: string) => {
    // In the browser, we could potentially read from document.cookie
    // but for now we return a safe empty object.
    return { name, value: '' };
  },
  set: () => {},
  delete: () => {},
  getAll: () => [],
  has: () => false,
});

export const headers = () => ({
  get: (name: string) => '',
  has: (name: string) => false,
  entries: () => [],
  keys: () => [],
  values: () => [],
});

export const revalidatePath = (path: string, type?: 'layout' | 'page') => {};
export const revalidateTag = (tag: string) => {};
export const unstable_cache = (fn: any) => fn;

export default {
  cookies,
  headers,
  revalidatePath,
  revalidateTag,
  unstable_cache,
};
